class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// ============================================================
// NOXH — Bandeau livraison + upsell (gift auto-add supprimé)
// ============================================================
(function () {

  // ---- Bandeau livraison avec compte à rebours ----
  function noxhInitDeliveryBanner() {
    var MONTHS = ['Jan','Fév','Mar','Avr','Mai','Juin','Juil','Aoû','Sep','Oct','Nov','Déc'];

    function addBusinessDays(date, n) {
      var d = new Date(date), added = 0;
      while (added < n) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6) added++;
      }
      return d;
    }

    function frDate(d) {
      return d.getDate() + ' ' + MONTHS[d.getMonth()];
    }

    var now = new Date();
    var elMin = document.getElementById('noxh-date-min');
    var elMax = document.getElementById('noxh-date-max');
    if (elMin) elMin.textContent = frDate(addBusinessDays(now, 3));
    if (elMax) elMax.textContent = frDate(addBusinessDays(now, 5));

    function tick() {
      var n = new Date();
      var midnight = new Date(n.getFullYear(), n.getMonth(), n.getDate() + 1, 0, 0, 0);
      var diff = midnight - n;
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var el = document.getElementById('noxh-countdown');
      if (el) {
        el.textContent = h + ' heure' + (h !== 1 ? 's' : '') + ' ' + m + ' min';
      }
    }

    tick();
    clearInterval(window._noxhCdTimer);
    window._noxhCdTimer = setInterval(tick, 30000);
  }

  async function refreshDrawer() {
    try {
      const res = await fetch('/?sections=cart-drawer,cart-icon-bubble');
      const data = await res.json();
      const parser = new DOMParser();

      if (data['cart-drawer']) {
        const doc = parser.parseFromString(data['cart-drawer'], 'text/html');
        const newInner = doc.querySelector('#CartDrawer');
        const current = document.getElementById('CartDrawer');
        if (newInner && current) {
          current.innerHTML = newInner.innerHTML;
          const overlay = document.getElementById('CartDrawer-Overlay');
          const drawerEl = document.querySelector('cart-drawer');
          if (overlay && drawerEl) {
            overlay.addEventListener('click', drawerEl.close.bind(drawerEl));
          }
        }
      }

      if (data['cart-icon-bubble']) {
        const doc = parser.parseFromString(data['cart-icon-bubble'], 'text/html');
        const newBubble = doc.querySelector('.shopify-section');
        const bubble = document.getElementById('cart-icon-bubble');
        if (newBubble && bubble) bubble.innerHTML = newBubble.innerHTML;
      }
    } catch (e) {
      console.warn('[NOXH] Refresh error:', e);
    }
    noxhInitDeliveryBanner();
  }

  // Bouton upsell : ajouter au panier via AJAX
  window.noxhAddUpsell = async function (btn) {
    const variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId || btn.disabled) return;
    btn.disabled = true;
    btn.classList.add('loading');
    btn.textContent = '...';
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });
      btn.classList.remove('loading');
      btn.classList.add('in-cart');
      btn.textContent = '✓ Ajouté';
      await refreshDrawer();
    } catch (e) {
      btn.disabled = false;
      btn.classList.remove('loading');
      btn.textContent = '+ Ajouter';
      console.warn('[NOXH] Upsell error:', e);
    }
  };

  document.addEventListener('DOMContentLoaded', function () {
    noxhInitDeliveryBanner();
  });

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(noxhInitDeliveryBanner, 750);
      });
    }
  });
})();
